<template>
  <div>
    <div>
      <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
        <div class="container-fluid">
          <div class="header-body dashboard-top-anlytics">
            <div class="row">
              <div class="col-xl-3 col-lg-6 dashboard-top-anlytics-item">
                <div
                  class="card card-stats mb-4 mb-xl-0"
                  show-footer-line="true"
                >
                  <!---->
                  <div class="card-body dashboard-top-status">
                    <div class="row">
                      <div class="col-auto">
                        <div
                          class="
                            icon icon-shape
                            text-white
                            rounded-circle
                            shadow
                            bg-gradient-red
                          "
                        >
                          <i class="ni ni-active-40"></i>
                        </div>
                      </div>
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">
                          امتیاز
                        </h5>
                        <span class="h2 font-weight-bold mb-0">
                          {{ GetCustomerScore }}</span
                        >
                      </div>
                    </div>
                    <!-- <p class="mt-3 mb-0 text-sm">
                      <span class="text-success mr-2"
                        ><i class="fa fa-arrow-up"></i> 3.48%
                      </span>
                      <span class="text-nowrap">تا ماه گذشته</span>
                    </p> -->
                  </div>
                  <!----><!---->
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 dashboard-top-anlytics-item">
                <div
                  class="card card-stats mb-4 mb-xl-0"
                  show-footer-line="true"
                >
                  <!---->
                  <div class="card-body dashboard-top-status">
                    <div class="row">
                      <div class="col-auto">
                        <div
                          class="
                            icon icon-shape
                            text-white
                            rounded-circle
                            shadow
                            bg-gradient-orange
                          "
                        >
                          <i class="ni ni-chart-pie-35"></i>
                        </div>
                      </div>
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">
                          اعتبار ریالی
                        </h5>
                        <span class="h2 font-weight-bold mb-0">
                          {{
                          GetCustomerValueAmount | numFormat | rial
                        }}</span>
                      </div>
                    </div>
                    <!-- <p class="mt-3 mb-0 text-sm">
                      <span class="text-success mr-2"
                        ><i class="fa fa-arrow-up"></i> 12.18% </span
                      ><span class="text-nowrap">از ماه گذشته</span>
                    </p> -->
                  </div>
                  <!----><!---->
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 dashboard-top-anlytics-item">
                <div
                  class="card card-stats mb-4 mb-xl-0"
                  show-footer-line="true"
                >
                  <!---->
                  <div class="card-body dashboard-top-status">
                    <div class="row">
                      <div class="col-auto">
                        <div
                          class="
                            icon icon-shape
                            text-white
                            rounded-circle
                            shadow
                            bg-gradient-green
                          "
                        >
                          <i class="ni ni-money-coins"></i>
                        </div>
                      </div>
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">
                          آخرین امتیاز کسب شده
                        </h5>
                        <span class="h2 font-weight-bold mb-0">{{
                          GetLastScore
                        }}</span>
                      </div>
                    </div>
                    <!-- <p class="mt-3 mb-0 text-sm">
                      <span class="text-danger mr-2"
                        ><i class="fa fa-arrow-down"></i> 5.72% </span
                      ><span class="text-nowrap">نسبت به سال گذشته</span>
                    </p> -->
                  </div>
                  <!----><!---->
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 dashboard-top-anlytics-item">
                <div
                  class="card card-stats mb-4 mb-xl-0"
                  show-footer-line="true"
                >
                  <!---->
                  <div class="card-body dashboard-top-status">
                    <div class="row">
                      <div class="col-auto">
                        <div
                          class="
                            icon icon-shape
                            text-white
                            rounded-circle
                            shadow
                            bg-gradient-info
                          "
                        >
                          <i class="ni ni-chart-bar-32"></i>
                        </div>
                      </div>
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">
                          مبلغ آخرین تراکنش
                        </h5>
                        <span class="h2 font-weight-bold mb-0">
                          {{ GetLastTransaction | numFormat | rial }}</span
                        >
                      </div>
                    </div>
                    <!-- <p class="mt-3 mb-0 text-sm">
                      <span class="text-success mr-2"
                        ><i class="fa fa-arrow-up"></i> 54.8% </span
                      ><span class="text-nowrap">روز گذشته</span>
                    </p> -->
                  </div>
                  <!----><!---->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt--7">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <div class="chart-area user-card">
                  <div class="user-level-scores">
                    <img class="user-tropy-level" src="/img/csoin21.png" />

                    <div class="user-level-details">
                      <h4>امتیاز شما : {{ GetCustomerScore }}</h4>
                      <span> سطح کاربری : </span>
                      <span class="level-title"> {{ GetCustomerSegment }}</span>
                    </div>
                  </div>
                  <h3>{{ userName }} عزیز خوش آمدید</h3>
                  <p>
                    شما می توانید با فعالیت در باشگاه مشتریان و بالا بردن سطح
                    کاربری خود به امتیاز ها و تخفیف های فوق العاده ای دست یابید .
                  </p>
                  <p>
                    باشگاه مشتریان در حال حاضر دارای چهار سطح است: برنز، نقره،
                    طلا و رویال، که شماکاربر عزیز مزایای مختلفی در ارتباط با هر
                    یک از سطوح دریافت خواهید کرد.
                  </p>
                  <button
                    class="btn btn-info float-left"
                    id="show-modal"
                    v-on:click="openModal"
                  >
                    نمایش جزئیات
                  </button>
                  <!-- <a @click="e => e.target.classList.toggle('active')">333</a> -->
                  <!-- <span class="show-details">نمایش  جزئیات</span> -->
                </div>
              </div>
              <!----><!---->
            </div>
          </div>
          <div class="col-xl-6 mb-6 mb-xl-0">
            <div class="card">
              <!-- <div class="card-header bg-transparent">
                <div class="row align-items-center">
                  <div class="col">
                    <h6 class="text-light text-uppercase ls-1 mb-1">گزارش</h6>
                    <h5 class="h3 text-white mb-0">میزان پیشرفت کاربری</h5>
                  </div>
                  <div class="col">
                    <ul class="nav nav-pills justify-content-end">
                      <li class="nav-item mr-2 mr-md-0">
                        <a class="nav-link py-2 px-3 active" href="#"
                          ><span class="d-none d-md-block">ماه</span
                          ><span class="d-md-none">M</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link py-2 px-3" href="#"
                          ><span class="d-none d-md-block">هفته</span
                          ><span class="d-md-none">W</span></a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="chart-area">
                  <div class="chartjs-size-monitor">
                    <div class="chartjs-size-monitor-expand">
                      <div class=""></div>
                    </div>
                    <div class="chartjs-size-monitor-shrink">
                      <div class=""></div>
                    </div>
                  </div>
                  <canvas
                    height="350"
                    id="salesChart"
                    style="display: block; width: 990px; height: 350px"
                    width="990"
                    class="chartjs-render-monitor"
                  ></canvas>
                </div>
              </div> -->
              <div class="card-body loyalty-dashboard-left">
                <div class="loyalty-dashboard-left-img">
                  <img src="/img/Wavy.png" alt="" />
                </div>
                <div class="loyalty-dashboard-left-description">
                  <h3>یک حساب و چند بهره !</h3>
                  <p>
                    هدف بنیادین باشگاه مشتریان ارائه هدایا و مزایا به کاربران
                    فعال از طریق جمع آوری و استفاده از امتیاز می باشد. نکته مثبت
                    باشگاه این است که کاربران با فعالیت در هر یک از خدمات
                    هُلدینگ زاگرس می توانند امتیاز به دست بیاورند و امتیاز به دست
                    آمده را در همان بخش یا بخش های دیگر و خدماتی دیگر استفاده
                    کنند . از این رو شما می توانید بازه بزرگتری از خدمات را برای
                    استفاده از امتیازهایتان در دسترس داشته باشید . این بدین
                    معناست که شما با یک کاربر می توانید در چندین بخش خدماتی
                    مانند، رزرو پرواز، رزرو هتل، خدمات هتل ها، خدمات تخصصی
                    فرودگاهی مانند فست ترک و بیزینس لانژ را استفاده کنند .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row mt-5">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-header border-0">
                <div class="row align-items-center">
                  <div class="col">
                    <h3 class="mb-0">روشهای دریافت امتیاز</h3>
                  </div>
                  <div class="col text-right">
                    <button type="button" class="btn btn-primary btn-sm">
                     نمایش همه
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table tablesorter">
                    <thead class="thead-light">
                      <tr>
                        <th>نوع فعالیت</th>
                        <td>ثبت نام</td>
                        <td>کسب مدال</td>
                        <td>ثبت دیدگاه مفید</td>
                        <td>رزرو خدمت</td>
                      </tr>
                      <tr>
                        <th>امتیاز</th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div
      :class="{ shown }"
      class="modalMain user-levels-modal"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              توضیحات درباره سطح کاربران
            </h5>
            <button
              type="button"
              class="close-modal"
              data-dismiss="modal"
              aria-label="Close"
              v-on:click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="header-levels-modal">
              باشگاه مشتریان پردیس دارای سطوح کاربری گوناگونیست که با توجه امتیاز
              کسب شده شما مشخص می گردد .شما می توانید با توجه به سطح کاربری که
              در باشگاه مشتریان دارید به امتیازها، تخفیف ها و امکانات گسترده ای
              که در نظر گرفته شده دسترسی یابید . در این بخش شرایط قرارگیری در
              سطوح گوناگون را خدمتتان توضیح می دهیم.
            </p>
            <div class="row modal-levels">
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/bronzeuser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح برنزی</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 7 می باشد</p>
                </div>
              </div>
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/silveruser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح نقره ای</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 70 می باشد</p>
                </div>
              </div>
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/golduser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح طلایی</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 160 می باشد</p>
                </div>
              </div>
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/royaluser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح رویال</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 300 می باشد</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a href="/club/scores" type="button" class="btn btn-primary">
              چگونه امتیاز کسب کنیم ؟
            </a>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="show = false"
              v-on:click="closeModal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal  End  -->
    <div
      class="modalMain user-levels-modal"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              توضیحات درباره سطح کاربران
            </h5>
            <button
              type="button"
              class="close-modal"
              data-dismiss="modal"
              aria-label="Close"
              v-on:click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="header-levels-modal">
              باشگاه مشتریان پردیس دارای سطوح کاربری گوناگونیست که با توجه امتیاز
              کسب شده شما مشخص می گردد .شما می توانید با توجه به سطح کاربری که
              در باشگاه مشتریان دارید به امتیازها، تخفیف ها و امکانات گسترده ای
              که در نظر گرفته شده دسترسی یابید . در این بخش شرایط قرارگیری در
              سطوح گوناگون را خدمتتان توضیح می دهیم.
            </p>
            <div class="row modal-levels">
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/bronzeuser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح برنزی</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 7 می باشد</p>
                </div>
              </div>
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/silveruser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح نقره ای</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 70 می باشد</p>
                </div>
              </div>
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/golduser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح طلایی</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 160 می باشد</p>
                </div>
              </div>
              <div class="col-sm modal-levels-qua">
                <div class="modal-levels-qua-img">
                  <img class="user-tropy-level" src="/img/royaluser.png" />
                </div>
                <div class="modal-levels-qua-left">
                  <h3>کاربر سطح رویال</h3>
                  <p>در این رتبه حداقل امتیاز مشخص شده 300 می باشد</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a href="/club/scores" type="button" class="btn btn-primary">
              چگونه امتیاز کسب کنیم ؟
            </a>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="show = false"
              v-on:click="closeModal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import GoToSurvey from "../../../components/club/GoToSurvey.vue";

import Chart from "chart.js";
export default {
  store,
  data() {
    return {
      checkUserPoll: false,
      show: false,
      score: 20,
      lastTransactionDate: "99/01/05",
      segment: "bronz",
      userName: "",
      lastScore: 0,
      valueAmount: 0,
      showModal: false,
      shown: "",
      salesChartID: "salesChart",
      ordersChartID: "ordersChart",
      bigLineChart: {
        allData: [
          [0, 20, 10, 30, 15, 40, 20, 60, 60],
          [0, 20, 5, 25, 10, 30, 15, 40, 40],
        ],
        activeIndex: 0,
      },
    };
  },
  components: { GoToSurvey },
  computed: {
    customerCredit() {
      return 0;
    },
    GetCustomerScore() {
      return this.$store.getters.GetCustomerClubData.score;
    },
    GetCustomerSegment() {
      return this.$store.getters.GetCustomerClubData.segment;
    },
    GetCustomerValueAmount() {
      return this.$store.getters.GetCustomerClubData.valueAmount;
    },
    GetLastScore() {
      return this.$store.getters.GetCustomerClubData.lastScore;
    },
    GetLastTransaction() {
      return this.$store.getters.GetCustomerClubData.lastValueAmount;
    },
  },
  created() {
    this.getCustomerValues();
  },
  mounted() {
    this.checkUserPollRegistered();

    // mounted() {
    //   let chart = new Chart(
    //     document.getElementById(this.salesChartID).getContext("2d"),
    //     {
    //       type: "line",
    //       data: {
    //         labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    //         datasets: [
    //           {
    //             label: "Performance",
    //             tension: 0.4,
    //             borderWidth: 4,
    //             borderColor: "#5e72e4",
    //             pointRadius: 0,
    //             backgroundColor: "transparent",
    //             data: this.bigLineChart.allData[1],
    //           },
    //         ],
    //       },
    //       options: {
    //         responsive: true,
    //         maintainAspectRatio: false,
    //         legend: {
    //           display: false,
    //         },
    //         tooltips: {
    //           enabled: true,
    //           mode: "index",
    //           intersect: false,
    //         },
    //         scales: {
    //           yAxes: [
    //             {
    //               barPercentage: 1.6,
    //               gridLines: {
    //                 drawBorder: false,
    //                 color: "rgba(29,140,248,0.0)",
    //                 zeroLineColor: "transparent",
    //               },
    //               ticks: {
    //                 padding: 0,
    //                 fontColor: "#8898aa",
    //                 fontSize: 13,
    //                 fontFamily: "Open Sans",
    //               },
    //             },
    //           ],
    //           xAxes: [
    //             {
    //               barPercentage: 1.6,
    //               gridLines: {
    //                 drawBorder: false,
    //                 color: "rgba(29,140,248,0.0)",
    //                 zeroLineColor: "transparent",
    //               },
    //               ticks: {
    //                 padding: 10,
    //                 fontColor: "#8898aa",
    //                 fontSize: 13,
    //                 fontFamily: "Open Sans",
    //               },
    //             },
    //           ],
    //         },
    //         layout: {
    //           padding: 0,
    //         },
    //       },
    //     }
    //   );
    //   // ordersChart.createChart(this.ordersChartID);
    // },
  },
  methods: {
    async checkUserPollRegistered() {
      const res = await this.$store.dispatch(
        "checkUserPollRegistered",
        localStorage.getItem("UserId")
      );
      if (res.data === true) {
        this.checkUserPoll = true;
      } else {
        this.checkUserPoll = false;
        setTimeout(
          function () {
            this.$toast.success(GoToSurvey, {
              position: "bottom-right",
              timeout: 40000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1.59,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              icon: true,
              rtl: true,
            });
          }.bind(this),
          3500
        );
      }
    },
    getCustomerValues() {
      this.score = this.$store.getters.GetCustomerClubData.score;
      this.segment = this.$store.getters.GetCustomerClubData.segment;
      this.valueAmount = this.$store.getters.GetCustomerClubData.valueAmount;
      this.lastScore = this.$store.getters.GetCustomerClubData.lastScore;
      this.userName = localStorage.getItem("Username");
    },

    openModal: function () {
      //  var ta = document.getElementByClass("modal-main");
      // ta.classList.toggle('open');
      // some code to filter users
      this.shown = "show";
    },
    closeModal: function () {
      //  var ta = document.getElementByClass("modal-main");
      // ta.classList.toggle('open');
      // some code to filter users
      this.shown = "";
    },
    initBigChart(index) {
      chart.destroy();
      chart = new Chart(
        document.getElementById(this.salesChartID).getContext("2d"),
        {
          type: "line",
          data: {
            labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            datasets: [
              {
                label: "Performance",
                tension: 0.4,
                borderWidth: 4,
                borderColor: "#5e72e4",
                pointRadius: 0,
                backgroundColor: "transparent",
                data: this.bigLineChart.allData[index],
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            tooltips: {
              enabled: true,
              mode: "index",
              intersect: false,
            },
            scales: {
              yAxes: [
                {
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(29,140,248,0.0)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    padding: 0,
                    fontColor: "#8898aa",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                  },
                },
              ],
              xAxes: [
                {
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(29,140,248,0.0)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    padding: 10,
                    fontColor: "#8898aa",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                  },
                },
              ],
            },
            layout: {
              padding: 0,
            },
          },
        }
      );
      this.bigLineChart.activeIndex = index;
    },
  },
};
</script>

<style scoped>
.widget {
  background-repeat: no-repeat;
  background-size: 30px 30px, contain;
  background-position: center;
  border-radius: 15px;
  width: 40px;
  height: 40px;
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 8px;
  color: slateblue;
}
.widget-card1-icon {
  background-image: url(../../../../public/img/iconfont/alarm.svg),
    linear-gradient(to right, lightgreen, lightgreen);
}
.widget-card2-icon {
  background-image: url(../../../../public/img/iconfont/diamond.svg),
    linear-gradient(to right, slateblue, slateblue);
}
.widget-card3-icon {
  background-image: url(../../../../public/img/iconfont/cart.svg),
    linear-gradient(to right, darksalmon, darksalmon);
}
.widget-card4-icon {
  background-image: url(../../../../public/img/iconfont/tack-pin.svg),
    linear-gradient(to right, lightskyblue, lightskyblue);
}
.btn-primary {
  margin-bottom: -22px;
}
.analytics-card1-color {
  color: green;
}
.analytics-card2-color {
  color: purple;
}
.analytics-card3-color {
  color: red;
}
.analytics-card4-color {
  color: blue;
}
/* ********* leftside cards style : start ********* */
/* *************** tour link style **************** */
.tour-link {
  background: linear-gradient(110deg, #fa8072 30%, #fa8072 30%);
  color: black;
  margin-top: 15px;
}
.tour-link a {
  color: black;
}
.tour-icon {
  width: 10%;
  margin-left: 20px;
  margin-right: 20px;
}
.user-level-scores {
  display: flex;
  margin: 10px 30px 50px;
  align-items: center;
}
.user-level-scores .user-tropy-level {
  width: 100px;
}
.user-level-scores .user-level-details {
  margin-right: 30px;
  line-height: 3;
}
.user-level-scores .user-level-details .level-title {
  font-weight: 800;
  font-size: 19px;
}
.user-card .show-details {
  float: left;
  display: block;
  margin-top: 33px;
  color: #3a74b5;
  cursor: pointer;
}
/* *********** business selected style ************ */
.selected-business {
  background: #cd5c5c;
  color: #fff;
  font-size: 13px;
  text-align: center;
  text-align: center;
}
.business-select select-business-item {
  border: 0;
  cursor: pointer;
}
.bussiness-select {
  background-color: white;
  border: 1px solid lightgrey;
  width: 100%;
}
/* *************** score management *************** */

.progress-box {
  background-color: lightgrey;
  width: 90%;
  /* width: 320px; */
  height: 5px;
}
.dashboard-top-anlytics .dashboard-top-status {
  height: 115px;
}
.progress-bar {
  height: 5px;
}
.progress-bar1 {
  background-color: green;
  width: 60% !important;
}
.progress-bar2 {
  background-color: fuchsia;
  width: 70px !important;
}
.progress-bar3 {
  background-color: blue;
  width: 100px !important;
}
/* ********** leftside cards style : end ********** */

.margin-right {
  margin-right: 0% !important;
}
.card {
  background-repeat: no-repeat;
  background-size: auto 80px, cover;
  background-position-x: 10%;
  background-position-y: 50%;
  border-radius: 15px;
  height: 100%;
}
.loyalty-dashboard-left {
  display: flex;
  align-items: center;
  height: 100%;
}
.loyalty-dashboard-left .loyalty-dashboard-left-img {
  flex: 1 1 45%;
  max-width: 45%;
  text-align: center;
}
.loyalty-dashboard-left .loyalty-dashboard-left-description {
  flex: 1 1 55%;
  max-width: 55%;
}
.loyalty-dashboard-left .loyalty-dashboard-left-img img {
  max-width:100%;
}
.report-card-bg {
  background-image: url(../../../../public/img/iconfont/reporting-svgrepo-com.svg),
    linear-gradient(to right, #fff, #fff);
}
.promotion-card-bg {
  background-image: url(../../../../public/img/iconfont/promotion-svgrepo-com.svg),
    linear-gradient(to right, var(--promotion-color1), var(--promotion-color2));
}
.aboutclub-card-bg {
  background-image: url(../../../../public/img/iconfont/customer-service-svgrepo-com.svg),
    linear-gradient(to right, var(--aboutclub-color1), var(--aboutclub-color2));
}
.news-card-bg {
  background-image: url(../../../../public/img/iconfont/report-svgrepo-com.svg),
    linear-gradient(to right, var(--news-color1), var(--news-color2));
}
.test1-card-bg {
  background-image: url(../../../../public/img/iconfont/reporting-svgrepo-com.svg),
    linear-gradient(to right, var(--test1-color1), var(--test1-color2));
}
.test2-card-bg {
  background-image: url(../../../../public/img/iconfont/reporting-svgrepo-com.svg),
    linear-gradient(to right, var(--test2-color1), var(--test2-color2));
}
/* ************************************************ */
/* ********************* CUSTOMER CLUB : start *************************** */
/* /////////// Analytics Card : start */
/* /////////// widget

/* /////////// card */
.analytics-card-container,
.page-view-container {
  padding: 15px;
  padding-top: 10px;
  /* margin-top: -15px; */
  /* margin-bottom: -80px !important; */
}
.analytics-card-box,
.page-view-box {
  padding: 5px;
}
.analytics-card {
  background: white;
  background-color: #ededed;
  border-radius: 5px;
}
.view-page-card {
  /* border-radius: 5px; */
  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);
  border: none;
}
.analytics-card-title {
  font-size: 12px;
  font-weight: 900;
  padding-top: 10px;
  padding-right: 65px;
}
.analytics-card-value {
  font-size: 10px;
  color: black;
  padding-top: 5px;
  padding-right: 65px;
  padding-bottom: 5px;
}
/* /////////// Analytics Card : end */
.card-bg-positioning {
  background-repeat: no-repeat;
  background-size: auto 50px, cover;
  background-position-x: 15%;
  background-position-y: 50%;
  border-radius: 20px;
  margin: 13px;
  padding: 12px;
}
.card-bg-positioning2 {
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  background-position: center;
}
.text-color {
  color: #3c3c3c !important;
  position: absolute;
  font-size: 13px;
  font-weight: bold;
  margin-top: 30px;
  margin-right: 10px;
}
.height {
  height: 140px;
}
.user-levels-modal .modal-dialog {
  max-width: 70%;
}
.user-levels-modal .modal-levels-qua {
  display: flex;
  padding: 20px 40px;
}
.user-levels-modal .modal-levels-qua .modal-levels-qua-img {
  flex: 1 1 35%;
  margin-left: 13px;
}
.user-levels-modal .modal-levels-qua .modal-levels-qua-img img {
  margin-left: 13px;
  width: 100%;
}
.user-levels-modal .modal-levels-qua .modal-levels-qua-left {
  flex: 1 1 75%;
}
.user-levels-modal .modal-levels-qua p {
  font-size: 14px;
}
.user-levels-modal .modal-footer {
  justify-content: space-between !important;
}
@media (max-width: 757px) {
  .header.bg-gradient-success {
    padding-top: 1rem !important;
  }
  .mt--7,
  .my--7 {
    margin-top: -7rem !important;
  }
  .dashboard-top-anlytics .dashboard-top-status {
    height: 70px;
  }
  .dashboard-top-anlytics .dashboard-top-anlytics-item {
    margin: 7px 0;
  }
  .dashboard-top-anlytics .dashboard-top-anlytics-item .row .col {
    margin-top: -5px;
  }

  .loyalty-dashboard-left {
    flex-direction: column;
  }
  .loyalty-dashboard-left .loyalty-dashboard-left-img {
    max-width: 100%;
    text-align: center;
  }
  .loyalty-dashboard-left .loyalty-dashboard-left-description {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
/* ********************* CUSTOMER CLUB : end *************************** */
</style>